import { useContext } from 'react';
import './TodoCompletion.css';
import { TodoContext } from '../../TodoContext';

function TodoCompletion() {
  const {completedTodos: completed, totalTodos: total, loading} = useContext(TodoContext);

  const renderPhrase = () => {
    if(!loading) {
      if(total === 0)
        return 'No To-Dos completed';

      return completed === total ? '🥳 Congratulations! You completed all your To-Dos! 🎊' : `completed: ${completed} out of ${total}`;
    }
    return 'loading progress...';
  }

  return (
    <div className='TodoCompletion'>
      <h2>
      {renderPhrase()}
      </h2>
      <progress max={total} value={completed} />
    </div>
  )
}

export { TodoCompletion };